import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';

import { addLocaleToPathIfNeeded } from '../../utils';

/**
 * Prefix to with current locale (in store)
 */
class LocalizedNavLink extends React.Component {
    reloadIfNeeded = () => {
        if (
            window.location.pathname === this.props.to ||
            window.location.pathname === `/${this.props.locale}${this.props.to}`
        ) {
            window.location.reload();
        }
    };

    render() {
        return (
            <NavLink
                {..._.omit(this.props, 'locale', 'dispatch')}
                to={addLocaleToPathIfNeeded(this.props)}
                onClick={this.props.onClick || this.reloadIfNeeded}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    };
};

export default connect(mapStateToProps)(LocalizedNavLink);



// WEBPACK FOOTER //
// ./src/components/router/LocalizedNavLink.js